// Hàm đợi element tồn tại
const waitForElement = (selector) => {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

// Khởi tạo observer sau khi element tồn tại
const initDrawerObserver = async () => {
    const element = await waitForElement('.drawer-cd-up-app-Ksl');
    
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (element.classList.contains('open')) {
                    // Ẩn shopify-chat khi drawer mở
                    const chatWidget = document.getElementById('shopify-chat');
                    if (chatWidget) {
                        chatWidget.style.display = 'none';
                    }
                } else {
                    // Hiện lại shopify-chat khi drawer đóng
                    const chatWidget = document.getElementById('shopify-chat');
                    if (chatWidget) {
                        chatWidget.style.display = '';
                    }
                }
            }
        });
    });

    observer.observe(element, {
        attributes: true,
        attributeFilter: ['class']
    });
};

// Khởi chạy
initDrawerObserver();